import * as React from "react"
import { useEffect } from "react";
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components";
import { groupedColumn, totalColumn, valueColumn } from "./columns"
import CatalogueAnalyzerGroupedVsSiteToggleButton from "./Actions"
import { catalogueAnalyzerRowClick } from "../@signals";
import { useCatalogueAnalyzerGroupedVsSiteSearch, useCatalogueAnalyzerGroupedVsSiteTable } from "./@hooks"


export default function CatalogueAnalyzerGroupedVsSiteTable() {

	const { isLoading, data, retailersList } = useCatalogueAnalyzerGroupedVsSiteSearch()
	const { toggleSelected, handleChangeToogle, handleClickRow, groupedLabel, isPriceSelected, title } = useCatalogueAnalyzerGroupedVsSiteTable()
	
	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!data.length) return <></>

	return <AppTableSeeker
		forceRender={catalogueAnalyzerRowClick.value}
		sx={{ height: 1 }}
		data={data}
		title={<TitleWithPopover title={title} />}
		columns={[
			groupedColumn(handleClickRow, groupedLabel),
			...retailersList.map(retailer => valueColumn(retailer, toggleSelected, isPriceSelected))
		]}
		options={{
			search: false,
			print: false,
			viewColumns: false,
			rowsPerPageOptions: [10, 20],
			customToolbar: () => <CatalogueAnalyzerGroupedVsSiteToggleButton value={toggleSelected} handleChange={handleChangeToogle} />
		}}
	/>
}